module.exports = __webpack_public_path__ + "img/Classifier6.87595446.png";